import { observable, reaction, makeObservable } from 'mobx';
import { type IkeClientService, Services } from '../services/index';

export class LicenseService implements IkeClientService {
	__priority: number = 100;

	@observable public hasNoLicense: boolean = false;

	constructor() {
		makeObservable(this);
	}

	init(): void {
		reaction(
			() => Services.Department.current,
			() => (this.hasNoLicense = false)
		);
	}
}
